import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/etity-form-provider.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import PageTitle from '@shared/layouts/components/page-title/page-title.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { setProp } from '@shared/helpers/operators';
import { useCommonHelper } from '@core/helpers/common-helper';

@Component({
  name: 'bpc-contact-relation-form',
  components: {
    'bpc-std-form': StdForm,
    'bpc-page-title': PageTitle,
  },
})
export default class ContactRelationForm extends Vue {
  $refs: {
    stdForm: InstanceType<typeof StdForm> & {
      saveEntity(): void;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: EntityFormProvider;
    };
  };
  public showForm: boolean = false;
  public entityId: any;
  public isSavingForm: boolean = false;
  public entityName: string = 'contact-relation';

  created() {
    if (this.$route.params.id) {
      this.onEdit(this.$route.params.id);
    } else {
      this.onNew();
    }
  }

  onNew() {
    this.entityId = null;
    this.showForm = true;
  }

  onEdit(id: any) {
    this.entityId = id;
    this.showForm = true;
  }

  onSavingEntity(event) {
    this.isSavingForm = event;
  }

  onFormSaved() {
    this.isSavingForm = false;
    this.$router.back();
  }

  onClickCancel() {
    this.$router.back();
  }
  onClickSave() {
    this.isSavingForm = true;
    this.$refs.stdForm.saveEntity();
  }

  get tenantType(): string {
    return this.$store.getters['centerSettings/centerSettings']['center_type'] || 'center';
  }

  public get resolvedConfigFileName(): string {
    const fileName = this.entityName.replaceAll('-', '_');
    return this.tenantType === 'center' ? fileName : `${fileName}_for_club`;
  }

  mounted() {
    this.$root.$on('relationCategoryChangedFromContactRelationForm', category => {
      this.setEmailValuesFromCategory(category);
    });
  }

  destroyed() {
    this.$root.$off('relationCategoryChangedFromContactRelationForm');
  }

  setEmailValuesFromCategory(category) {
    if (category && this.$refs.stdForm?.formModel) {
      setProp(this.$refs.stdForm.formModel, 'booking_emails', category?.booking_emails || false);
      setProp(
        this.$refs.stdForm.formModel,
        'accounting_emails',
        category?.accounting_emails || false,
      );
      setProp(this.$refs.stdForm.formModel, 'other_emails', category?.other_emails || false);
    }
  }

  i = useCommonHelper().generateUUIDv4();

  // mounted() {
  //   this.$root.$on('changeType', val => {
  //     this.$refs.stdForm.formModel.contactIndividual = null;
  //   });
  //   this.$root.$on('updateContact', event => {
  //     this.$refs.stdForm.formModel.to_invoice = event.to_invoice === 1;
  //     this.$refs.stdForm.formModel.when_to_invoice = event.when_to_invoice_value;
  //   });
  // }

  // destroyed() {
  //   this.$root.$off('changeType');
  //   this.$root.$off('updateContact');
  // }

  // onFormSaved(e) {
  //   this.$emit('entity-saved', e);
  // }
  // onSavingEntity(event) {
  //   this.$emit('saving-entity', event);
  // }
  // deleteMediaFile(mediaId) {
  //   this.$emit('delete-media-file', { mediaId: mediaId, entityId: this.entityId });
  // }
  // saveEntity() {
  //   this.$refs.stdForm.saveEntity();
  // }

  // @Watch('formModel', { immediate: true, deep: true })
  // onFormModelChange() {
  //   this.$emit('input', this.formModel);
  // }
}
